import {size, mapValues, createSelector, createStructuredSelector} from 'helpers';
import {module} from 'store/common';
import {subscription} from 'store/session';
import {limits} from './limits.selector';
import {inProgress as goalsInProgress} from 'store/goals/selectors/goals';
import {inProgress as activitiesInProgress} from 'store/activities/selectors/activities';

export const count = createStructuredSelector({
  activities: createSelector(activitiesInProgress.activities, size),
  diary: createSelector(state => state.diary.index, size),
  goals: createSelector(goalsInProgress, size),
  notes: createSelector(state => state.notes.index, size),
  recurring: createSelector(activitiesInProgress.recurring, size),
});

export const list = createSelector(
  [ subscription, limits, count ],
  ( subscription, limits, count ) => ({
    canAdd: mapValues(count, (currentValue, name) => currentValue < limits[name]),
    googleCalendar: subscription.premium,
    identityModule: subscription.premium,
  })
);

export const restricted = createSelector(
  [ limits, count, module ],
  ( limits, count, module ) => ({
    restricted: count[module] > limits[module],
    message: limits[module] + ' ' + moduleLabel(module),
  }),
);

const moduleLabel = module => module.replace('activities', 'one time activities')
                                    .replace('recurring', 'recurring activities')
                                    .replace('diary', 'diary records');
